import Swiper from 'swiper/bundle';

export default function initializeMainSlider() {
    document.querySelectorAll('.main-slider').forEach(function (slider) {
        const swiper = new Swiper(slider, {
            loop: true,
            speed: 1000,
            preloadImages: false,
            // autoplay: {
            //     delay: 5000,
            //     disableOnInteraction: false,
            // },
            pagination: {
                el: '.main-slider__pagination',
                loop: true,
                clickable: true,
                bulletClass: 'slider-pagination__bullet',
                bulletActiveClass: 'slider-pagination__bullet--active',
            },
        });
    });
}